import { c as _c } from "react/compiler-runtime";
import { Link } from "@tanstack/react-router";
import { MapPin } from "lucide-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AddPlaceCard() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Link, {
      to: "/admin/lagg-till-plats",
      className: "group rounded-lg border p-5 transition-colors hover:border-brand/30 hover:bg-brand/5",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-3",
        children: [/*#__PURE__*/_jsx(MapPin, {
          className: "h-6 w-6 text-gray-400 group-hover:text-brand"
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h2", {
            className: "font-semibold text-gray-900",
            children: "L\xE4gg till plats"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm text-gray-500",
            children: "S\xF6k och importera fr\xE5n OpenStreetMap"
          })]
        })]
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}